<template>
  <v-tabs v-if="this.JourneyTypes[0].id !== null" background-color="grey lighten-3" show-arrows v-model="journeyTabs">
    <v-tabs-slider color="accent"></v-tabs-slider>
    <v-tab v-for="journey in journeys" :key="journey.id">{{ journey.name }}</v-tab>
    <v-tab-item v-for="journey in journeys" :key="journey.id">
      <question-filters :journey="journey"></question-filters>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import QuestionFilters from './Questions/QuestionFilters';

export default {
  name: 'question-journey-tabs',
  components: { QuestionFilters },
  data: () => ({
    journeyTabs: null
  }),
  computed: {
    ...mapGetters(['JourneyTypes', 'UserHasRole']),
    journeys: function() {
      if (_.isNull(this.JourneyTypes[0].id)) {
        return [{ name: 'loading...', id: '123' }];
      }
      const initial = [this.JourneyTypes[0].journeys[0]];
      let main = _.orderBy(this.JourneyTypes[1].journeys, 'name');
      if (this.UserHasRole('Property Broker')) {
        main = _.filter(main, journey => journey.name !== 'Business Funding');
      }
      return _.uniqBy([...initial, ...main], 'id');
    }
  }
};
</script>

<style lang="scss" scoped>
.answer-list-container {
  height: calc(100vh - 150px);
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
